import { render, staticRenderFns } from "./IconFileImg.vue?vue&type=template&id=3ece6213&"
import script from "./IconFileImg.vue?vue&type=script&lang=js&"
export * from "./IconFileImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports